import { useEffect, useState } from 'react';
import { getGrupo } from '../services/api';

/**
 * Ela divide uma casa com alguém?
 *
 * É o que decide se "Meu / Da casa" aparece ao lançar. Até 05/10 a opção só
 * aparecia quando algum método de pagamento já estava marcado como da casa —
 * a ideia era que o cartão fosse o controle principal e isto, a correção. Na
 * prática, quem acabava de aceitar um convite não tinha método marcado nenhum
 * e ficava sem ONDE dizer que um gasto era da casa: a feature existia e não
 * tinha porta de entrada.
 *
 * "Casa" aqui é casa com mais alguém que aceitou. Sozinha, marcar um gasto
 * como da casa não mostra nada a ninguém, e o controle seria promessa vazia.
 *
 * Falhou a leitura? Vale `false`: a opção some, e nada é marcado por engano.
 */
export const estaEmCasa = (g: { casa: unknown; sozinha: boolean } | null | undefined): boolean =>
  !!g && !!g.casa && !g.sozinha;

export const useTemCasa = (): boolean => {
  const [tem, setTem] = useState(false);
  useEffect(() => {
    let vivo = true;
    // Dentro de uma promessa: qualquer falha — a rede, ou a leitura não existir
    // num ambiente de teste — cai no `catch` e vira "não", em vez de derrubar
    // o formulário de lançamento por causa de um seletor opcional.
    Promise.resolve()
      .then(() => getGrupo())
      .then(g => { if (vivo) setTem(estaEmCasa(g)); })
      .catch(() => { if (vivo) setTem(false); });
    return () => { vivo = false; };
  }, []);
  return tem;
};
